




















































import { Component, Prop, Emit, Mixins, Watch } from 'vue-property-decorator';
import ChartLayout from './ChartLayout.vue';
import Highcharts from 'highcharts';
import stockInit from 'highcharts/modules/stock';
import exportingInit from 'highcharts/modules/exporting';
import VariableList from './VariableList.vue';
import {
    EventBus,
    TypeEventBus,
    FilterDateEvent,
    getDateFromDateFormatApi,
    hasElements,
    OptionalVariableData,
    OptionalVariableSelect,
    trackingColors,
    getDictionaryFromChoices,
    Lazy,
    getDateFormattedAsMoment,
    existItemInList,
    getIndexFromList,
    MarkerVehicleHistoricalUUID,
    getCategoriesForChartAxis,
    ID,
    isNullOrEmpty
} from '../utils';
import { debounceTime, takeUntil } from 'rxjs/operators';
import {
    DataParameter,
    dateTypes,
    HistoricalDataVehicleParameter,
    HistoricalParams,
    HistoricalParamsByParameter,
    HistoricalStats,
    isParamInfoValid,
    TrackingParameter,
    TypeFilterDate,
    VariableInfo
} from '../models';
import { Subject } from 'rxjs';
import moment from 'moment';
import { TrackingService } from '../api';
import { getVehicleData, NotificationStoreHelper, RootStoreHelper, VehicleCompanyStoreHelper } from '../mixins';
import { Destroyed } from '../decorators';
import Axios from 'axios';
import { Mutation } from 'vuex-class';
import { GetterType, LastReportMap, PendingRequestEvent, VehicleMap, VehiclesEvent } from '../../../store';
import { Method } from '../utils';
import DateRange from './DateRange.vue';
import { VariablesOptions } from '../../tracking/utils';
import { clearDuplicatedChoices, existPointsToChart, getChoicesDuplicatedIds, isChartDeadZone, PointWithoutData, SerieZone } from '../../core/utils/chart-utils';
stockInit(Highcharts);
exportingInit(Highcharts);
Highcharts.setOptions({
    time: {
         useUTC: false
    },
    lang: {
        months: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Setiembre',
            'Octubre',
            'Noviembre',
            'Diciembre'
        ],
        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'],
        weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
    }
});

const EMPTY_RESULT = { tracking: [] };

let zoomButton: any = null;

type NavigatorFilter = { min: number; max: number };

@Component({
    components: { VariableList, ChartLayout }
})
export default class VariableChart extends Mixins(NotificationStoreHelper, RootStoreHelper, VehicleCompanyStoreHelper) {
    @Prop() paramsInfo: HistoricalParams;
    @Prop() selectedParamsInfo: HistoricalParams;
    @Prop({ default: null }) variables: OptionalVariableData | null;
    @Prop() open: boolean;
    @Prop() variablesInformation: any;
    @Prop() chartMin: number; // this was added to persist while changing variables
    @Prop() chartMax: number;
    @Prop() mapHeight: number;
    @Prop() vehiclesHistoricalData: any;
    @Prop() selectedVehicleInSelector: string;
    @Prop() expandedStats: boolean;
    @Prop() historicalMarkers: MarkerVehicleHistoricalUUID[];
    defaultNoData: string = 'No hay información';
    noDataToShow: string = 'No hay información para graficar. Consulte la pestaña Datos';
    noDataToShowSecondary: string = 'La variable secundaria no tiene datos para graficar. Consulte la pestaña Datos';
    noDataText: string = this.defaultNoData;
    noVariableSelected: string = 'No hay ninguna variable seleccionada';
    variablesData: any = {};
    pendingRequest: boolean = false;
    unSubscribe$: Subject<void> = new Subject<void>();
    navigatorFilter$: Subject<NavigatorFilter> = new Subject<NavigatorFilter>();
    updateArgs = [true, true, { duration: 1000 }];
    vehicleSelectedInSelector: any = null;
    selectedVariable: any = null;
    variableToOverlap: OptionalVariableSelect = null;
    cancelRequest: any = null;
    secondaryVariable: any = null;
    resultSelectedVariable: any;
    resultOverlapVariable: any;
    removeOverlapVariable: boolean = false;
    disablePlusButton: boolean = false;
    shouldDisplayNoInformation: boolean = false;
    params: any = null;

    date_to: any = null;
    date_from: any = null;
    tokenWS: any = null;

    @Watch('$_getDateRange')
    observableGetDateForm(value: DateRange) {
        this.clearData();
    }

    @Watch('$_getOpenStatsPanel')
    observeOpenStatsPanel(value: boolean) {
        if (value) {
            this.checkIfDisplayNoVariableData();
        }
    }

    created() {
        this.clearData();
    }

    clearSecondaryVariable(){
        if(this.variableToOverlap && this.variableToOverlap['description']){
            this.removeVariableFromChartByItsName(this.variableToOverlap['description'])
        }
        this.variableToOverlap = null;
        this.resultOverlapVariable = null;
        
        this.removeSecondaryVariableSelected();
    }

    clearData() {
        this.selectedVariable = null;
        this.secondaryVariable = null;
        this.variableToOverlap = null;
        this.resultSelectedVariable = null;
        this.resultOverlapVariable = null;
        this.clearSeries();
    }

    checkIfDisplayNoVariableData() {
        if (this.selectedVariable == null) {
            this.clearData();
            this.shouldDisplayNoInformation = true;
            this.noDataText = this.noVariableSelected;
            this.pendingRequestEffect(false);
        }
    }


    @Watch('shouldDisplayNoInformation')
    watchShouldDisplayNoInformation(val) {
        if (this.variableToOverlap !== null) {
            this.removeSecondaryVariableSelected();
            this.resultOverlapVariable = null;
        }
        this.$emit('variable-without-information', val);
    }

    vehicleSelectedInChartLayout(vehicle) {
        this.$emit('vehicle-selected-in-selector', vehicle);
    }

    @Watch('vehicleSelectedInSelector')
    watchVehicleSelectedInSelector(val) {
        this.$emit('vehicle-selected-in-selector', val);
    }

    @Emit()
    changeFilterDate(event: FilterDateEvent | null, chartMin: number, chartMax: number) {}

    updateDateFromTo(min, max) {
        this.date_from = this.toIsoFormat(new Date(min));
        this.date_to = this.toIsoFormat(new Date(max));
    }

    toIsoFormat(date) {
        let tzoffset = date.getTimezoneOffset() * 60000; //offset in milliseconds
        let localISOTime = new Date(date - tzoffset)
            .toISOString()
            .split('.')
            .shift();
        return localISOTime;
    }

    @Watch('selectedVariable')
    watchSelectedVariable(val) {
        this.$emit('selected-variable', val);
    }

    @Watch('selectedVehicleInSelector')
    watchVehiclesSelector(vehicles) {
        if (vehicles !== null) {
            this.assignVehicleInSelector(vehicles);
        }
    }

    @Watch('$_getSelectedVehiclesByID')
    watchSelectedVehicles(vehicles) {
        this.removeNoInformationText();
        this.cancelLoadValues();
        this.clearData();
        this.pendingRequestEffect(true);
        if (this.$_getSelectedVehiclesByID.length > 1) {
            this.assignVehicleInSelector(null);
            this.clearSeries();
            this.resultSelectedVariable = null;
            this.resultOverlapVariable = null;
            this.selectedVariable = null;
            this.variableToOverlap = null;
            this.$_setVariablesResponse(null);
            // this.chartLegendVisibility(false);
            this.removeSecondaryVariableSelected();
            if ((this.selectedVariable = null)) {
                this.pendingRequestEffect(false);
            }
        }
    }

    removeSecondaryVariableSelected() {
        // this.removeOverlapVariable = true;
        this.variableList.removeOverlapVariable();
    }

    getSelectedVehicles() {
        let vehicles: any = [];
        this.$_getSelectedVehicles.map(function(vehicle) {
            vehicles.push({
                vehicle_id: vehicle.id,
                vehicle_plate: vehicle.vehicle_plate
            });
        });
        return vehicles;
    }

    modifyResetButtom(target: any) {
        zoomButton = target.renderer
            .button(
                'Quitar zoom',
                null,
                null,
                function() {
                    target.xAxis[0].setExtremes(null, null);
                },
                {
                    zIndex: 20
                }
            )
            .attr({
                id: 'resetZoom',
                align: 'right',
                title: ''
            })
            .add()
            .align(
                {
                    align: 'right',
                    x: -15,
                    y: 6
                },
                false,
                null
            );
    }
    defaultChartOptions: any = {
        tooltip: {
            backgroundColor: '#ffffff',
            shared: false,
            split: false,
            valueSuffix: '',
            valueDecimals: 2,
            formatter: function(tooltip) {
                //default formatter code's output: it uses numerical values
                let defaultTooltip:Array<string> = tooltip.defaultFormatter.call(this, tooltip);
                //default formatter output example:
                //[<span style=\"color:#2638BE\">●</span> Estado del vehículo: <b>1.00</b><br/>]

                if (!this.point.series.yAxis.categories){
                    return defaultTooltip
                }
                
                //si la variable tiene categorias (choices) modifico el valor numerico a texto
                for (let index = 0; index < defaultTooltip.length; index++) {
                    let currentTooltip:string = defaultTooltip[index];
                    // Extraigo el valor numerico entre <b></b>
                    let regex = /<b>(.*?)<\/b>/;
                    let match = regex.exec(currentTooltip);

                    let numericValue: number | null = null;

                    if(match !== null){
                        //corregir casos "4 096.00"
                        const dotValue = match[1];
                        // Eliminar los espacios en blanco y convertir el string a número
                        const numero = parseFloat(dotValue.replace(/\s/g, ''));

                        // Redondear el número y convertirlo a entero
                        const numeroRedondeado = Math.round(numero);
                        numericValue = numeroRedondeado
                    }

                    if(numericValue !== null){
                        //obtengo el nombre de la categoria
                        let categoryName = this.point.series.yAxis.categories[numericValue];
                        //Spliteo el tooltip antes y despues del valor
                        let parts = currentTooltip.split("<b>");
                        let beforeValue = parts[0];
                        let afterValue = parts[1].split("</b>")[1];

                        //actualizo el tooltip con el nombre de la categoria
                        currentTooltip = beforeValue + "<b>" + categoryName + "</b>" + afterValue;
                        defaultTooltip[index] = currentTooltip;
                    }
                }
                return defaultTooltip
            }
        },
        chart: {
            marginLeft: 130,
            marginRight: 130,
            zoomType: 'x',
            resetZoomButton: {
                position: {
                    verticalAlign: 'top',
                    x: -30,
                    y: 30
                },
                theme: {
                    fill: 'white',
                    stroke: 'silver',
                    r: 0,
                    states: {
                        hover: {
                            fill: '#3C4A66',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                }
            },
            events: {
                selection: event => {
                    // this.modifyResetButtom(event.target);
                    if (event.resetSelection) {
                        this.changeFilterDate(null, -1, -1);
                    } else {
                        this.updateDateFromTo(event.xAxis[0].min, event.xAxis[0].max);
                        this.changeFilterDate(
                            {
                                typeFilterDate: TypeFilterDate.RANGE_DATE,
                                range: {
                                    datetime_to: getDateFormattedAsMoment(event.xAxis[0].max),
                                    datetime_from: getDateFormattedAsMoment(event.xAxis[0].min)
                                }
                            },
                            event.xAxis[0].min,
                            event.xAxis[0].max
                        );
                    }
                }
            }
        },
        plotOptions: {
            series: {
                dataGrouping: 'high',
                animation: {
                    duration: 2000,
                    easing: 'swing'
                },
                connectNulls: true,
                showInNavigator: true
            }
        },
        rangeSelector: {
            enabled: false
        },
        yAxis: [
            {
                gapGridLineWidth: 0,
                labels: {
                    format: '{value}',
                    style: {
                        color: trackingColors[1]
                    },
                    align: 'right'
                },
                offset: 0,
                opposite: false,
                showLastLabel: true
            },
            {
                // segundo Y-Axis
                //right yaxis
                labels: {
                    format: '{value}',
                    style: {
                        color: trackingColors[0]
                    },
                    align: 'left'
                },
                offset: 0,
                gapGridLineWidth: 0,
                opposite: true,
                showLastLabel: true
            }
        ],
        xAxis: {
            allowOverlap: true,
            ordinal: false,
            type: 'datetime',
            minPadding: 0,
            maxPadding: 0,
            labels: {
                formatter: function() {
                    return getDateFormattedAsMoment(this.value, dateTypes.dddLT)
                }
            },
            events: {
                setExtremes: event => {
                    if (event && !event.min && !event.max) {
                        // zoomButton.destroy();
                        this.changeFilterDate(null, -1, -1);
                    } else if (event && event['trigger'] === 'navigator') {
                        // this.updateDateFromTo(event.min, event.max);
                        if (this.chartOptions.navigator.enabled) {
                            this.navigatorFilter$.next({
                                min: event.min,
                                max: event.max
                            });
                        }
                    }
                }
            }
        },
        title: {
            text: ''
        },
        scrollbar: {
            barBackgroundColor: '#8eb4ff',
            buttonBackgroundColor: '#8eb4ff'
        },
        series: [],
        credits: {
            enabled: false
        },
        legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'top'
        },
        navigator: {
            enabled: true,
            yAxis: {
                labels: {
                    enabled: true
                },
                title: {
                    text: 'Valores'
                },
                opposite: false,
                softMin: 0
            }
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: [
                        'downloadPNG',
                        'downloadJPEG',
                        'downloadPDF',
                    ]
                }
            }
        }
    };
    chartOptions: any = this.defaultChartOptions;
    defaultHistoricalStats: HistoricalStats = {
        min: '0',
        max: '0',
        mean: '0',
        median: '0'
    };
    variableAndChoices: {
        [key: string]: string;
    } = {}

    get shouldDisplayChart(): boolean {
        return this.chartOptions && this.chartOptions.series && this.chartOptions.series.length && !this.pendingRequest;
    }

    removeDataFromOverlapVariable() {
        this.resultOverlapVariable = null;
        this.variableToOverlap = null;
    }

    @Watch('variables')
    watchVariables() {
        if (this.variables == null) {
            this.pendingRequestEffect(true);
        } else {
            this.clearData();
            this.checkIfDisplayNoVariableData();
        }
    }

    selectFirstVariable() {
        if (this.variables && !hasElements(this.chartOptions.series)) {
            this.pendingRequestEffect(true);
            this.selectedVariable = this.selFirstVariable();
            this.updateVehiclesInParamsInfo(this.$_getSelectedVehiclesByID);
            this.loadValues(this.paramsInfo, this.selectedVariable);
        }
    }

    selFirstVariable() {
        if (this.variables) {
            let firstVariable = this.variables[0];
            return firstVariable;
        }
    }

    async loadValues(paramsInfo: HistoricalParams, selectedVariable) {
        if (isParamInfoValid(paramsInfo) && selectedVariable) {
            this.pendingRequestEffect(true);
            let data: any = this.checkIfVariableHasSavedData(selectedVariable['description']);
            let dataHasElements = data && data.tracking.length ? true : false;
            if (!dataHasElements) {
                this.resultSelectedVariable = await this.getVariableData(paramsInfo, selectedVariable);
            } else {
                this.resultSelectedVariable = data;
            }
            if (this.resultSelectedVariable !== 'error') {
                if (this.variableToOverlap !== null) {
                    this.selectedVariable = selectedVariable;
                    this.completeHistoricalDataByVehiclesParameterRequest(
                        this.resultSelectedVariable,
                        selectedVariable,
                        true
                    );
                } else {
                    //this.clearFilterDateEffect();
                    this.completeHistoricalDataByVehiclesParameterRequest(
                        this.resultSelectedVariable,
                        selectedVariable,
                        false
                    );
                }
                if (this.variableToOverlap == null) {
                    this.$emit('clear-variable-data-tab');
                }
                this.updateVariableDataTab(this.resultSelectedVariable, selectedVariable);
            } else {
                this.shouldDisplayNoInformation = true;
                this.delayPendingRequestEffect();
            }
        }
    }

    checkIfVariableHasSavedData(variable) {
        if (this.$_getVariablesResponse[variable] !== undefined) {
            return this.$_getVariablesResponse[variable];
        }
        return null;
    }

    @Mutation(PendingRequestEvent.COMPLETED_HISTORICAL_DATA_BY_PARAMETERS_STATS_REQUEST)
    $_completedHistoricalRequest: Method<any, void>;

    @Mutation(PendingRequestEvent.PENDING_HISTORICAL_DATA_BY_PARAMETERS_STATS_REQUEST)
    $_pendingHistoricalDataRequest: Lazy<void>;

    async getHistoricalDataByParametersStats() {
        let companyId = this.$_getSelectedCompanyById as string;
        if (this.$_getSelectedVehiclesByID.length == 1 || this.existVehicleSelectedInSelector) {
            let paramsObj = this.selectedParamsInfo !== null ? this.selectedParamsInfo : this.paramsInfo;
            if (paramsObj && paramsObj.datetime_from) {
                let token = Axios.CancelToken.source();
                let varParams: HistoricalParamsByParameter = {
                    datetime_from: paramsObj['datetime_from'],
                    datetime_to: paramsObj['datetime_to'],
                    variable_name: '',
                    variable_id: -1,
                    vehicles: paramsObj.vehicles,
                    company_id: companyId
                };
                let allStats: Array<object> = [];
                if (this.selectedVariable !== null) {
                    varParams.variable_name = this.selectedVariable['description'];
                    varParams.variable_id = this.selectedVariable['id'];
                    await TrackingService.getHistoricalDataByParametersStats(varParams, token, this.$_isMock).then(
                        response => {
                            if (response.stats) {
                                allStats.push({
                                    variable: varParams.variable_name,
                                    vehicles: varParams.vehicles,
                                    min: response.stats.min,
                                    max: response.stats.max,
                                    median: response.stats.median,
                                    mean: response.stats.mean
                                });
                            }
                        }
                    );
                }

                if (this.variableToOverlap !== null) {
                    varParams.variable_name = this.variableToOverlap['description'];
                    varParams.variable_id = this.variableToOverlap['id'];
                    await TrackingService.getHistoricalDataByParametersStats(varParams, token, this.$_isMock).then(
                        response => {
                            if (response.stats) {
                                allStats.push({
                                    variable: varParams.variable_name,
                                    vehicles: varParams.vehicles,
                                    min: response.stats.min,
                                    max: response.stats.max,
                                    median: response.stats.median,
                                    mean: response.stats.mean
                                });
                            }
                        }
                    );
                }
                this.$_completedHistoricalRequest(allStats);
            }
        }
    }

    async getVariableData(paramsInfo, variable) {
        let params = this.buildHistoricalParamsByParameter(paramsInfo, variable);
        variable = variable['description'];
        let varDescription = this.getVarDescriptionByKey(variable);
        let vehiclesSelected = this.$_getSelectedVehiclesByID;

        this.params = params;
        if(this.tokenWS){
            this.tokenWS.cancel();
        }
        this.tokenWS = Axios.CancelToken.source();
        let _this = this;
        this.shouldDisplayNoInformation = false;

        const variableResponse = async () => {
            let varData;
            let data: any = await TrackingService.getHistoricalDataByVehiclesParameter(params, this.tokenWS, false)
                .then((result: HistoricalDataVehicleParameter) => {
                    _this.checkIfVariableResponseHasData(result, variable);
                    varData = result;
                })
                .catch(error => {
                    varData = 'error';

                    if (vehiclesSelected.length > 1) {
                        this.assignVehicleInSelector(null);
                        this.updateVehiclesInParamsInfo(this.$_getSelectedVehiclesByID);
                        if (varDescription !== null) {
                            this.$_showParameterError(
                                'No hay datos de ' +
                                    '"' +
                                    varDescription +
                                    '"' +
                                    'para el vehículo: ' +
                                    this.getVehicleDescriptionFromVehicleId(paramsInfo.vehicles.toString())
                            );
                        }
                    } else {
                        if (varDescription !== null) {
                            this.$_showParameterError('No hay datos para ' + '"' + varDescription + '"');
                        }
                    }

                    if (this.resultSelectedVariable == null) {
                        this.shouldDisplayNoInformation = true;
                    }
                    this.pendingRequestEffect(false);
                });
            return varData;
        };
        let getVariableInfo = await variableResponse();
        return getVariableInfo;
    }

    completeHistoricalDataByVehiclesParameterRequest(response, selectedVariable: VariableInfo, refresh) {
        if (hasElements(response.tracking)) {
            
            this.saveChartData(response, selectedVariable, false);
            if (refresh) {
                this.saveChartData(this.resultOverlapVariable, this.variableToOverlap, true);
            }
        }
        this.delayPendingRequestEffect();
    }

    checkChoicesWithResponseChartValues(selectedVariable: VariableInfo, response) {
        /*
           Metodo que revisa si la variable tiene choices duplicados 
           si tiene categorias duplicadas modifico el choices para que tenga solamente una categoria con el valor mas alto
           tambien en los puntos de la respuesta debo reemplazar los valores de las categorias duplicadas por el valor mas alto
        */
        let variableChoices = selectedVariable.choices;
        // console.log("choices de la variable", variableChoices);
        let res = response;

        if (variableChoices) {
            let duplicatedCategories: {
                [key: string]: number[];
            } =  getChoicesDuplicatedIds(variableChoices);

            // console.log("duplicatedCategories", duplicatedCategories);

            //si hay categorias duplicadas recorro los puntos de la respuesta por cada vehiculo y reemplazo el valor de la categoria duplicada por el valor mas alto
           if(Object.keys(duplicatedCategories).length > 0){

                //recorro los puntos de la respuesta
                for (let index = 0; index < response.tracking.length; index++) {
                    const vehicleData = response.tracking[index];
                    let vehiclePoints = vehicleData.data;


                    for (let index = 0; index < vehiclePoints.length; index++) {
                        const point = vehiclePoints[index];
                        let value = point.value;

                        if(value !== undefined){
                            //recorro las categorias duplicadas
                            for (const category in duplicatedCategories) {
                                if (duplicatedCategories.hasOwnProperty(category)) {
                                    const categoryValues = duplicatedCategories[category];
                                    const categoryMaxValue = Math.max(...categoryValues);
                                    //si el valor del punto esta en la categoria duplicada y no es el valor mas alto
                                    if(categoryValues.indexOf(value) !== -1 && value !== categoryMaxValue){
                                        //reemplazo el valor del punto por el valor mas alto de la categoria duplicada
                                        let oldValue = point.value;
                                        point.value = categoryMaxValue;
                                        // console.log(`reemplazo el valor ${oldValue} por ${categoryMaxValue}`)
                                    }
                                }
                            }
                        }
                    }
                }

                // console.log("selectedVariable.choices 1", selectedVariable.choices);

                //recorro los choices y elimino las categorias duplicadas, dejo solamente la categoria con el valor mas alto
                variableChoices = clearDuplicatedChoices(duplicatedCategories, variableChoices);
                
            }

            this.variableAndChoices[selectedVariable['description']] = variableChoices;
            // console.log("guardo choices this.variableAndCHoices", {
            //     [selectedVariable['description']]: variableChoices
            // });
        }


        return { 
            res, 
            variable: selectedVariable }
        ;


    }

    getVariableWithUpdatedChoices(selectedVariable: VariableInfo, uniqueValues:number[], stats:HistoricalStats){
        /* Ajustar choices para los que llegan con asterisco ej: {0=Error, *=Normal} 
           Obtengo el nombre de esa categoria y genero un nuevo choices con los valores que faltan
           choices: "{0=Error, *=Normal}"
           output: "{0=Error, 1=Normal, 2=Normal}"
        */
    //    console.clear();
    //    console.log("getVariableWithUpdatedChoices choices:", selectedVariable.choices);
         if(selectedVariable.choices){
            let choices = selectedVariable.choices;
            //si choices tiene asterisco
            if(choices.indexOf('*') !== -1){
                //me quedo con el nombre de esa categoria con asterisco
                const pattern = /\*=(.*?)(?:,|\})/;
                const match = choices.match(pattern);
                const asteriskCategory = match ? match[1].trim() : ""; //ej: Normal

                if(asteriskCategory !== ""){
                    //recorro los valores unicos de la grafica
                    for (let index = 0; index < uniqueValues.length; index++) {
                        const uniqueValue = uniqueValues[index];
                        
                        //me fijo si el valor existe en el choices
                        let regex = new RegExp(`\\b${uniqueValue}=\\w+\\b`);
                        if (!regex.test(choices)) {
                            //si no existe en el choices
                            //agrego el nuevo valor con su descripcion
                            choices = choices.slice(0, -1) + `,${uniqueValue}=${asteriskCategory}}`;
                        }
                    }
                    choices = this.clearModifiedChoices(choices);
                }
            }
            selectedVariable.choices = choices;
            // console.log("getVariableWithUpdatedChoices resultado:", selectedVariable.choices);
         }

         return selectedVariable
    }

    clearModifiedChoices(choices:string){
       // Escapar los caracteres especiales de la opción para usarlos en la expresión regular
        const optionToRemove = choices.replace(/.*\*=(.*?),.*/, '$1');
        const escapedOption = optionToRemove.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        
        // Construir la expresión regular dinámicamente
        const regex = new RegExp("\\*=" + escapedOption + ",", "g");
        
        // Remover la opción del texto
        let cleanedChoices = choices.replace(regex, '');
        // Si la opción estaba al final del texto, también la removemos sin la coma final
        cleanedChoices = cleanedChoices.replace(new RegExp("\\*=" + escapedOption + "$"), '');

        // console.log("cleanedChoices", cleanedChoices);
        return cleanedChoices;
    }

    saveVariablesData(variable, data) {
        let key = variable.toString();
        let newObj = { [key]: data };
        if (variable !== VariablesOptions.VEHICLE_STATE) {
            this.$_setVariablesResponse(newObj);
        }
    }

    completeOverlapRequest(result, selectedVariable, varToOverlap) {
        this.saveVariablesData(varToOverlap, result);

        let dataVarOverlap = this.checkIfVariableResponseHasData(result, varToOverlap);
        if (!dataVarOverlap) {
            this.saveChartData(this.resultSelectedVariable, selectedVariable, false);
            this.variableToOverlap = null;
            this.secondaryVariable = null;
            this.removeSecondaryVariableSelected();
            if (this.variableToOverlap == null) {
                this.$emit('clear-variable-data-tab');
            }
            this.updateVariableDataTab(this.resultSelectedVariable, selectedVariable);
        } else {
            this.saveChartData(result, varToOverlap, true);
            this.updateVariableDataTab(result, varToOverlap);
        }
        this.delayPendingRequestEffect();
    }

    checkIfVariableResponseHasData(result, variable) {
        let varDescription = this.getVarDescriptionByKey(variable);
        if (hasElements(result.tracking)) {
            this.saveVariablesData(variable, result);
            return true;
        } else {
            if (
                this.resultSelectedVariable == null &&
                this.variableToOverlap == null &&
                this.resultOverlapVariable == null
            ) {
                this.shouldDisplayNoInformation = true;
                this.$emit('variable-without-information');
            }
            if (varDescription !== null) {
                this.$_showParameterError('No hay datos para ' + '"' + varDescription + '"');
                this.pendingRequestEffect(false);
            }
            return false;
        }
    }

    setLinesColor() {
        if (this.$_getSelectedVehiclesByID.length > 1 && !this.existVehicleSelectedInSelector) {
            this.chartOptions.yAxis[1].labels.style.color = '#804000';
        } else if (this.$_getSelectedVehiclesByID.length > 1 && this.existVehicleSelectedInSelector) {
            this.chartOptions.yAxis[1].labels.style.color = trackingColors[0];
        } else if (this.$_getSelectedVehiclesByID.length == 1) {
            this.chartOptions.yAxis[1].labels.style.color = trackingColors[0];
        }
    }

    overlapSerie(series, selectedVariable, stats, unique:number[]) {
        if (hasElements(series)) {
            let suffixValue = selectedVariable.unit != '' ? ' ' + selectedVariable.unit : '';
            if (selectedVariable) {
                // console.log("overlapserie selectedVariable", selectedVariable)
                this.updateChartCategories(0, selectedVariable, stats, unique);

                let checkIfSerieExistInChartOptions = existItemInList(this.chartOptions.series, 'var_name', selectedVariable['description'])


                if (!checkIfSerieExistInChartOptions) {
                    this.chartOptions.series.push({
                        data: series[0].data,
                        name: series[0].name,
                        var_name: selectedVariable['description'],
                        serie_stats: series[0]['serie_stats'],
                        color: trackingColors[1],
                        shadow: true,
                        connectNulls: true,
                        zoneAxis: 'x',
                        zones: series[0]['zones'],
                        dataGrouping: {
                            enabled: false
                        },
                        tooltip: {
                            valueSuffix: suffixValue
                        }
                    });
                }
            }
        }else{
            this.showVariableWithNoDataMessage(false);
        }
    }

    resetOptions() {
        this.chartOptions.series = [];
        this.variableToOverlap = null;
        this.$_setVariablesResponse(null);
    }

    showVariableWithNoDataMessage(isPrimaryVariable: boolean){
        if(isPrimaryVariable){
            this.noDataText = this.noDataToShow;
            this.shouldDisplayNoInformation = true;
        }else{
            this.$_showEmptyLastReport(this.noDataToShowSecondary);
        }
    }

    replaceCurrentSerie(series, selectedVariable, stats, unique:number[]) {
        // console.log("reemplazo serie actual");
        if (!hasElements(series)) {
            if (this.selectedVariable && this.variableToOverlap == null && this.variables !== null) {
                this.resetOptions();
                this.showVariableWithNoDataMessage(true);
            }
            this.pendingRequest = false;
        } else {
            this.updateChartCategories(1, selectedVariable, stats, unique);
            this.$set(this.chartOptions, 'series', series);
        }
    }

    updateChartCategories(axis, selectedVariable, stats, uniqueValues: number[]) {
        this.chartOptions.yAxis[axis].tickPositions = undefined
        if (selectedVariable.choices) {
            let choicesForSelectedVariable = this.variableAndChoices[selectedVariable['description']]
            // console.log("choicesForSelectedVariable", choicesForSelectedVariable);
            this.chartOptions.yAxis[axis].categories = getDictionaryFromChoices(choicesForSelectedVariable)
            this.chartOptions.yAxis[axis].labels.format = '';
            this.chartOptions.tooltip.valueSuffix = ' ';
            this.chartOptions.yAxis[axis].tickPositions = getCategoriesForChartAxis(this.chartOptions.yAxis[axis].categories);
        } else {
            this.chartOptions.yAxis[axis].categories = undefined;
            if (selectedVariable.unit && selectedVariable.unit != '') {
                this.chartOptions.yAxis[axis].labels.format = '{value} ' + selectedVariable.unit;
                this.chartOptions.tooltip.valueSuffix = ' ' + selectedVariable.unit;
            } else {
                this.chartOptions.yAxis[axis].labels.format = '{value}';
                this.chartOptions.tooltip.valueSuffix = ' ';
            }
        }

        if (this.chartMin != -1) {
            this.$set(this.chartOptions.xAxis, 'min', this.chartMin);
            this.$set(this.chartOptions.xAxis, 'max', this.chartMax);
        } else {
            this.$set(this.chartOptions.xAxis, 'min', undefined);
            this.$set(this.chartOptions.xAxis, 'max', undefined);
        }
    }

    saveChartData(response, selectedVariable, action) {
        let copyOfSelectedVariable = JSON.parse(JSON.stringify(selectedVariable));
        selectedVariable = this.getVariableWithUpdatedChoices(copyOfSelectedVariable, response.unique, response.stats);
        let { res, variable} = this.checkChoicesWithResponseChartValues(selectedVariable, response);
        copyOfSelectedVariable = variable;
        response = res;

        let parameterSerie = this.parameterToSeriesEffect(response, selectedVariable);

        let series = parameterSerie['series'];
        this.setLinesColor();
        if (action) {
            //Superponer serie
            this.overlapSerie(series, selectedVariable, parameterSerie['stats'], response.unique);
        } else {
            this.replaceCurrentSerie(series, selectedVariable, parameterSerie['stats'], response.unique);
        }
        this.$set(this.chartOptions, 'generalStats', parameterSerie['stats']);
        //if chartMin is -1 there is no global filter
    }

    @Watch('paramsInfo', { immediate: true, deep: true })
    async observerParamsInfo(paramsInfo: HistoricalParams) {
        // localStorage.setItem('variablesData', JSON.stringify({}));
        // this.$emit('reset-variable-data-items');
        this.$_setVariablesResponse(null);
        
        if (isParamInfoValid(this.paramsInfo) && this.selectedVariable !== null) {
            this.clearSeries();
            this.$_setVariablesResponse(null);
            this.pendingRequestEffect(true);
            this.resultOverlapVariable = null;
            this.resultSelectedVariable = null;
            // this.variableToOverlap = null;
            if (isParamInfoValid(paramsInfo) && this.selectedVariable) {
                // this.$emit('clear-variable-data-tab');
                if (this.variableToOverlap !== null) {
                    this.resultOverlapVariable = await this.getVariableData(this.paramsInfo, this.variableToOverlap);
                    this.resultSelectedVariable = await this.getVariableData(this.paramsInfo, this.selectedVariable);
                    this.completeHistoricalDataByVehiclesParameterRequest(
                        this.resultSelectedVariable,
                        this.selectedVariable,
                        true
                    );
                    this.updateVariableDataTab(this.resultOverlapVariable, this.variableToOverlap);
                    this.updateVariableDataTab(this.resultSelectedVariable, this.selectedVariable);
                } else {
                    this.resultSelectedVariable = await this.getVariableData(this.paramsInfo, this.selectedVariable);
                    this.completeHistoricalDataByVehiclesParameterRequest(
                        this.resultSelectedVariable,
                        this.selectedVariable,
                        false
                    );
                    this.updateVariableDataTab(this.resultSelectedVariable, this.selectedVariable);
                }
            }
        }
        this.delayPendingRequestEffect();
    }
    checkIfResponseIsError() {}

    @Emit()
    updateVariableDataTab(variableResult, selectedVariable: string) {}

    resetVariablesData() {
        this.resultSelectedVariable = null;
        this.resultOverlapVariable = null;
        this.variableToOverlap = null;
    }

    getVehicleIDFromVehiclePlate(vehiclePlate) {
        let vehicle_id;
        for (let i = 0; i < this.$_getVehiclesFromSelectedCompany.length; i++) {
            if (vehiclePlate === this.$_getVehiclesFromSelectedCompany[i].vehicle_plate.toString()) {
                vehicle_id = this.$_getVehiclesFromSelectedCompany[i].id;
            }
        }
        return vehicle_id;
    }
    

    delayPendingRequestEffect() {
        //  setTimeout(() => {
        this.pendingRequestEffect(false);
        // }, 0);
    }

    @Watch('variables')
    observerVariables(variables: OptionalVariableData): void {
        if (this.variables && this.open) {
            this.pendingRequestEffect(true);
            // this.selectedVariable = this.variables[0];
            this.updateVehiclesInParamsInfo(this.$_getSelectedVehiclesByID);
            this.loadValues(this.paramsInfo, this.selectedVariable);
        }
    }

    mounted() {
        const filterNavigator$ = this.navigatorFilter$
            .pipe(
                debounceTime(500),
                takeUntil(this.unSubscribe$)
            )
            .subscribe((filter: NavigatorFilter) => {
                this.updateDateFromTo(filter.min, filter.max);
                this.changeFilterDate(
                    {
                        typeFilterDate: TypeFilterDate.RANGE_DATE,
                        range: {
                            datetime_to: getDateFormattedAsMoment(filter.max),
                            datetime_from: getDateFormattedAsMoment(filter.min)
                        }
                    },
                    filter.min,
                    filter.max
                );
            });

        EventBus.$on(TypeEventBus.RESET_STATS_ZOOM, () => {
            this.resetSelection();
        });
    }

    reloadVariableChartsFromFilterDate() {
        this.removeNoInformationText();
        this.pendingRequestEffect(true);
        this.clearSeries();
        this.resultSelectedVariable = null;
        this.resultOverlapVariable = null;
        if (this.selectedVariable !== null) {
            this.loadValues(this.paramsInfo, this.selectedVariable);
        }
    }

    filterMock(): void {
        const min = getDateFromDateFormatApi('2019-09-26T00:04:24').getTime();
        const max = getDateFromDateFormatApi('2019-09-26T00:14:14').getTime();
        this.triggerFilter(min, max);
        this.navigatorFilter$.next({
            min,
            max
        });
    }

    resetSelection(): void {
        this.triggerFilter(null, null);
    }

    triggerFilter(newMin: number | null, max: number | null): void {
        let chartObject = this.$refs.chartObject as HTMLFormElement;
        if (chartObject && chartObject.chart && chartObject.chart.xAxis) {
            chartObject.chart.xAxis[0].update({
                max: max !== null ? max : undefined,
                min: newMin !== null ? newMin : undefined
            });
            chartObject.chart.xAxis[0].setExtremes(newMin, max);
        }
    }

    disableAreaSelection(): void {
        this.chartOptions.chart.zoomType = undefined;
        this.chartOptions.navigator.enabled = false;
    }

    enableAreaSelection(): void {
        this.chartOptions.chart.zoomType = 'x';
        this.chartOptions.navigator.enabled = true;
    }

    pendingRequestEffect(value: boolean) {
        this.pendingRequest = value;
        this.$emit('pending-request-effect', value);
    }

    clearFilterDateEffect() {
        this.changeFilterDate(null, -1, -1);
    }

    clearVehicleSelector(item) {
        if (this.$_getSelectedVehiclesByID.length > 1) {
            this.removeSecondaryVariableSelected();
            this.$_setVariablesResponse(null);
            this.variableToOverlap = null;
            this.assignVehicleInSelector(null);
            let selectedVehicles =
                this.$_getSelectedVehiclesByID && this.$_getSelectedVehiclesByID.length
                    ? this.$_getSelectedVehiclesByID.join(',')
                    : '';
            this.updateVehiclesInParamsInfo(selectedVehicles);
            this.loadValues(this.paramsInfo, this.selectedVariable);
            this.$emit('clear-vehicle-selector', 'null');
        }
    }

    updateChartWithVehicleSelected(vehicleDescription) {
        if (!isNullOrEmpty(vehicleDescription)) {
            this.$_setVariablesResponse(null);
            this.assignVehicleInSelector(vehicleDescription);
            let vehicleId = this.getVehicleIdFromVehicleDescription(vehicleDescription);
            this.updateVehiclesInParamsInfo(vehicleId);
        }
    }

    getVehicleIdFromVehicleDescription(description: string){
        let vehicleId:ID = -1;
        let index = this.$_getSelectedVehicles.findIndex(vehicle => vehicle.description === description);
        if(index !== -1){
            vehicleId = this.$_getSelectedVehicles[index].id;
        }
        return vehicleId;
    }

    updateVehiclesInParamsInfo(vehicles) {
        this.$emit('update-params-info', vehicles);
    }

    chartLegendVisibility(val) {
        this.chartOptions.legend.enabled = val;
    }

    assignVehicleInSelector(value) {
        this.vehicleSelectedInSelector = value;
    }

    parameterToSeriesEffect(historicalData: HistoricalDataVehicleParameter, selectedVariable: string) {
        let self = this;
        if (historicalData && historicalData.tracking && !hasElements(historicalData.tracking)) {
            return [];
        } else {
            let series: any[] = [];
            let generalStats: HistoricalStats = {
                min: '0',
                max: '0',
                median: '0',
                mean: '0'
            };
            let quantityOfVehicles = historicalData && historicalData.tracking && historicalData.tracking.length;

            try {
                historicalData.tracking.forEach((track: TrackingParameter, index: number) => {
                    let positions: any[] = [];
                    let vehiclePlate = this.getVehicleDescriptionFromVehicleId(track.vehicle_id.toString());
                    let serieDottedZones:Array<SerieZone> = []; 
                    generalStats = historicalData.stats;
                    track.data.forEach((dt: DataParameter, index:number) => {
                        let currentPoint = dt;
                        let currentPointHasData = typeof(dt.value) == 'number';
                        
                            if(!currentPointHasData){
                                currentPoint['raw_value'] = dt.value;
                                currentPoint.value = null;   
                            }
                            let nextPoint = currentPoint;
                            let nextPointIndex = index + 1;
                            if (nextPointIndex < track.data.length) {
                                nextPoint = track.data[index + 1];
                            }

                            //comparo el punto actual con el siguiente y me fijo si es zona para marcar punteada
                            let isDeadZone = isChartDeadZone(currentPoint, nextPoint);

                            if (isDeadZone) {
                                //agrego el punto anterior
                                serieDottedZones.push({
                                    value: moment(currentPoint.timestamp).valueOf()
                                });

                                //agrego el punto siguiente
                                serieDottedZones.push({
                                    value: moment(nextPoint.timestamp).valueOf(),
                                    dashStyle: 'dot'
                                });
                            }
                            positions.push([getDateFromDateFormatApi(dt.timestamp).getTime(), currentPoint.value]);
                    });

                    let exitsPointsToChart = existPointsToChart(positions)


                    if (self.variables && selectedVariable && exitsPointsToChart) {
                        
                        let serieName = quantityOfVehicles == 1 ? selectedVariable['description'] : vehiclePlate;
                        let suffixValue =
                            selectedVariable['unit'] && selectedVariable['unit'] != ''
                                ? ' ' + selectedVariable['unit']
                                : '';

                        let serieInfo = {
                            name: serieName,
                            color: self.getLineColor(track.vehicle_id, index),
                            data: positions,
                            var_name: serieName,
                            serie_stats: {
                                vehicle: vehiclePlate,
                                var: serieName,
                                data: track.stats
                            },
                            connectNulls: true,
                            shadow: true,
                            zoneAxis: 'x',
                            zones: serieDottedZones,
                            dataGrouping: {
                                enabled: true,
                                approximation: 'high'
                            },
                            tooltip: {
                                valueSuffix: suffixValue
                            },
                            yAxis: 1
                        };

                        series.push(serieInfo);
                    }
                });
            } catch {
                //
            }

            return {
                stats: generalStats,
                series: series
            };
        }
    }

    getLineColor(vehicleId: number, currentIndex: number){
        let lineColor = trackingColors[currentIndex];
        let historicalMarkers = this.historicalMarkers;
        if(historicalMarkers && hasElements(historicalMarkers)){
            let indexVehicleInHistoricalMarkers = getIndexFromList(historicalMarkers, 'vehicle_id', vehicleId);

            if(indexVehicleInHistoricalMarkers !== -1){
                lineColor = historicalMarkers[indexVehicleInHistoricalMarkers]['color'];
            }
        }
        return lineColor
    }

    getVehicleDescriptionFromVehicleId(id) {
        let vehicleDescription;
        for (let i = 0; i < this.$_getVehiclesFromSelectedCompany.length; i++) {
            if (id === this.$_getVehiclesFromSelectedCompany[i].id.toString()) {
                vehicleDescription = this.$_getVehiclesFromSelectedCompany[i].description;
            }
        }
        return vehicleDescription;
    }

    resetVariableList(){
        this.cancelLoadValues();
        this.clearData();
        this.$emit('clear-variable-data-tab');
        this.pendingRequestEffect(false);
        this.noDataText = this.noVariableSelected;
        this.shouldDisplayNoInformation = true;
    }

    async handleSelectVariable(variable) {
        this.noDataText = this.defaultNoData;
        this.removeNoInformationText();
        this.pendingRequestEffect(true);
        let variableName = variable && variable['description'] ? variable['description'] : '';
        let previousSelectedVariable = this.selectedVariable;
        let previousSecondaryVariable = this.variableToOverlap;
        this.selectedVariable = variable;
        let variableData: any = this.checkIfVariableHasSavedData(variableName);
        let varDataHasElements = variableData && variableData.tracking.length ? true : false;
        let varData;
        if (!varDataHasElements) {
            if (isParamInfoValid(this.paramsInfo) && this.selectedVariable) {
                varData = await this.getVariableData(this.paramsInfo, variable);
            } else {
                varData = [];
            }
        } else {
            varData = variableData;
        }
        if (varData !== 'error') {
            if (this.checkIfVariableResponseHasData(varData, variableName)) {
                if (previousSelectedVariable !== null) {
                    this.$emit('remove-variable-data-tab', previousSelectedVariable);
                }
                if (this.variableToOverlap == null) {
                    this.$emit('clear-variable-data-tab');
                }
                this.updateVariableDataTab(varData, variable);
                this.loadValues(this.paramsInfo, this.selectedVariable);
            } else {
                if (!this.checkIfVariableHasSavedData(previousSelectedVariable)) {
                    this.selectedVariable = null;
                    this.shouldDisplayNoInformation = true;
                } else {
                    this.selectedVariable = previousSelectedVariable;
                    this.variableToOverlap = previousSecondaryVariable;
                }
            }
        }
        this.delayPendingRequestEffect();
    }

    get existSelectedVariable() {
        return this.selectedVariable ? true : false;
    }

    get existVehicleSelectedInSelector() {
        if (this.vehicleSelectedInSelector == null || this.vehicleSelectedInSelector === 'null') {
            return false;
        } else {
            return true;
        }
    }

    get shouldDisplayPlusButton() {
        return this.$_getSelectedVehiclesByID.length == 1 ? this.existSelectedVariable : this.existVehicleSelectedInSelector && this.existSelectedVariable;
    }

    getVarDescriptionByKey(variable) {
        return variable && variable['description'] ? variable['description'] : null;
    }

    removeNoInformationText() {
        this.shouldDisplayNoInformation = false;
    }

    async handleClickBehaviour(selectedVariable, varToOverlap, action) {
        let selectedVariableName = selectedVariable['description'];
        let variableOverlappedName = varToOverlap['description'];
        this.removeNoInformationText();
        if (action) {
            this.pendingRequestEffect(true);
            // window.console.log('add');
            let previousSecondaryVariable = this.variableToOverlap;
            this.secondaryVariable = null;
            let varData;
            let variableData = this.checkIfVariableHasSavedData(variableOverlappedName);
            let varDataHasElements = variableData && variableData.tracking.length ? true : false;
            if (!varDataHasElements) {
                if (isParamInfoValid(this.paramsInfo) && this.selectedVariable) {
                    varData = await this.getVariableData(this.paramsInfo, varToOverlap);
                } else {
                    varData = [];
                }
            } else {
                varData = variableData;
            }

            if (varData !== 'error') {
                if (this.checkIfVariableResponseHasData(varData, variableOverlappedName)) {
                    let savedData = this.checkIfVariableHasSavedData(variableOverlappedName);
                    let dataHasElements = savedData && savedData.tracking.length ? true : false;
                    this.resultOverlapVariable = dataHasElements ? savedData : varData;
                    if (previousSecondaryVariable !== null) {
                        this.$emit('remove-variable-data-tab', previousSecondaryVariable);
                    }
                    this.selectedVariable = selectedVariable;
                    this.variableToOverlap = varToOverlap;
                    this.chartOptions.series.splice(1, 1);
                    this.completeOverlapRequest(
                        this.resultOverlapVariable,
                        this.selectedVariable,
                        this.variableToOverlap
                    );
                } else {
                    if (previousSecondaryVariable !== null) {
                        this.secondaryVariable = previousSecondaryVariable;
                        this.variableToOverlap = previousSecondaryVariable;
                    } else {
                        this.variableToOverlap = null;
                        this.removeSecondaryVariableSelected();
                    }
                }
            }
            EventBus.$emit(TypeEventBus.ENABLE_PLUS_BUTTON);
            this.delayPendingRequestEffect();
        } else {
            // window.console.log('remover');
            let varName = this.getVarDescriptionByKey(varToOverlap);
            this.removeVariableFromChartByItsName(varName);
            this.variableToOverlap = null;
            this.$emit('remove-variable-data-tab', varToOverlap);
            if (this.selectedVariable && !this.checkIfVariableHasSavedData(this.selectedVariable['description'])) {
                this.shouldDisplayNoInformation = true;
            }
            EventBus.$emit(TypeEventBus.ENABLE_PLUS_BUTTON);
        }
        this.delayPendingRequestEffect();
    }

    removeVariableFromChartByItsName(varName) {
        let chartObject = this.$refs.chartObject as HTMLFormElement;
        let chartSeries = this.chartOptions.series;
        if (chartObject && chartObject.chart && chartObject.chart.yAxis && chartObject.chart.yAxis[0]) {
            this.chartOptions.yAxis[0].tickPositions = undefined;
            this.chartOptions.yAxis[0].categories = undefined;
        }
        let indexVariableToRemove = getIndexFromList(chartSeries, 'var_name', varName)
        if (indexVariableToRemove !== -1) {
            if (chartObject && chartObject.chart && chartObject.chart.yAxis) {
                chartObject.chart.series[indexVariableToRemove].remove(true);
                chartSeries.splice(indexVariableToRemove, 1);
            }
        }
    }

    get chartObject(): HTMLFormElement {
        return this.$refs.chartObject as HTMLFormElement;
    }

    buildHistoricalParamsByParameter(
        params: HistoricalParams,
        variable: OptionalVariableSelect
    ): HistoricalParamsByParameter {
        let parameters = {
            ...params,
            variable_name: variable && variable['description'] ? variable['description'] : '',
            variable_id: variable && variable['id'] ? variable['id'] : null
        };
        return parameters;
    }

    get variableList(): HTMLFormElement {
        return this.$refs.variableList as HTMLFormElement;
    }

    cancelLoadValues(): void {
        if (this.cancelRequest) {
            this.cancelRequest.cancel();
            this.cancelRequest = null;
        }
    }

    clearSeries(): void {
        this.chartOptions.series = [];
    }

    @Destroyed
    unSubscribe(): void {
        this.cancelLoadValues();
        this.clearSeries();
        this.unSubscribe$.next();
        this.unSubscribe$.complete();
        this.navigatorFilter$.next();
        this.navigatorFilter$.complete();
    }
}
